import React from 'react';
import { useTranslation } from 'react-i18next';
import useDevices from '@hooks/useDevices';
import { Button, Form, Modal, Select } from 'antd';

const { Option } = Select;

type AudioDevicesModalProps = {
  open: boolean;
  closeModal: () => void;
  currentInput: string | null;
  currentOutput: string | null;
  updateInputDevice: (deviceId: string) => void;
  updateOutputDevice: (deviceId: string) => void;
};

export const AudioDevicesModal = ({
  open,
  closeModal,
  currentInput,
  currentOutput,
  updateInputDevice,
  updateOutputDevice
}: AudioDevicesModalProps) => {
  const { t } = useTranslation('common');
  const devices = useDevices();
  const inputDevices = devices.audioInputDevices;
  const outputDevices = devices.audioOutputDevices;

  return (
    <Modal
      title="Audio devices"
      centered
      open={open}
      onCancel={closeModal}
      footer={[
        <Button data-testid="close-notes-modal" key="cancel" onClick={closeModal}>
          {t('Close')}
        </Button>
      ]}
    >
      <Form.Item label={t('Input Device')} labelCol={{ span: 8 }}>
        <Select
          onChange={(value) => {
            updateInputDevice(value);
          }}
          value={currentInput}
          data-testid="input-device-select"
        >
          {inputDevices.map((device) => (
            <Option value={device.deviceId} key={device.deviceId}>
              {device.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label={t('Output Device')} labelCol={{ span: 8 }}>
        <Select
          onChange={(value) => {
            updateOutputDevice(value);
          }}
          value={currentOutput}
          data-testid="output-device-select"
        >
          {outputDevices.map((device) => (
            <Option value={device.deviceId} key={device.deviceId}>
              {device.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Modal>
  );
};
